/**
 * Hook que retorna os post-its de um slide e reage a postitChange.
 */

import { useEffect, useState } from 'react'

import { useAdapter } from '../../adapter'
import type { PostitEntry } from '../../types/adapter'

export function usePostits(slideIndex: number): PostitEntry[] {
  const adapter = useAdapter()
  const [postits, setPostits] = useState<PostitEntry[]>(adapter.getPostits(slideIndex))

  useEffect(() => {
    setPostits(adapter.getPostits(slideIndex))
    const off = adapter.on('postitChange', () => {
      // Re-pega o snapshot atual do adapter — patch ja foi aplicado in-place.
      setPostits([...adapter.getPostits(slideIndex)])
    })
    const offSnap = adapter.on('sessionSnapshot', () => {
      setPostits([...adapter.getPostits(slideIndex)])
    })
    return () => {
      off()
      offSnap()
    }
  }, [adapter, slideIndex])

  return postits
}
